/**
 * Единая точка общения с бэкендом.
 *
 * До рефакторинга константы API_BASE / SITE_URL и функция toAbsoluteUrl были
 * скопированы в 5 файлов — смена домена требовала правок в каждом.
 */

export const API_BASE =
  import.meta.env.VITE_API_BASE ?? "https://tfec-ifas.tj/backend/index.php";

export const SITE_URL = import.meta.env.VITE_SITE_URL ?? "https://tfec-ifas.tj";

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }

  get isNotFound() {
    return this.status === 404;
  }
}

/** Бэкенд отдаёт относительные пути к файлам — приводим к абсолютным. */
export function toAbsoluteUrl(url, fallback = null) {
  if (!url) return fallback;
  if (/^(https?:)?\/\//i.test(url)) return url;
  return `${SITE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
}

/**
 * GET-запрос к API.
 *
 * @param {string} path   Хвост после index.php, например "" или "/reports".
 * @param {object} params Query-параметры (undefined/null отбрасываются).
 * @param {AbortSignal} signal Сигнал отмены — обязателен для запросов в эффектах.
 * @returns {Promise<unknown>} Содержимое поля `data` ответа.
 */
export async function apiGet(path = "", { params = {}, signal } = {}) {
  const url = new URL(`${API_BASE}${path}`);

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, String(value));
    }
  }

  const response = await fetch(url, {
    signal,
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new ApiError(`Request failed: ${url.pathname}`, response.status);
  }

  const payload = await response.json();
  return payload?.data ?? null;
}
